import { Component } from '@angular/core';
import { IWizItemRenderer, WizBaseCollector } from '@wizeoo/akm-component-lib';
import { KeyPair } from '@wizeoo/akm-compute-lib';
/**
 * rendu des items du widget list
 */
@Component({
  selector: 'list-widget-item-renderer',
  templateUrl: './list-widget-item.renderer.html',
})
export class ListWidgetItemRenderer implements IWizItemRenderer<null, KeyPair> {
  data: KeyPair;
  owner: WizBaseCollector;
}
